"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _FormContext = _interopRequireDefault(require("./FormContext"));
const FormLabel = _ref => {
  let {
    htmlFor,
    className,
    children
  } = _ref;
  const {
    controlId,
    required
  } = _react.default.useContext(_FormContext.default);
  htmlFor = htmlFor ?? controlId;
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: htmlFor,
    className: (0, _arkReact.concatClassName)('formLabel', className)
  }, children, /*#__PURE__*/_react.default.createElement("span", {
    className: 'required'
  }, required === true && '*'));
};
process.env.NODE_ENV !== "production" ? FormLabel.propTypes = {
  htmlFor: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
} : void 0;
FormLabel.defaultProps = {
  htmlFor: undefined,
  className: undefined,
  children: undefined
};
var _default = exports.default = FormLabel;